import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/shared/observability/src/lib/client-logging.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/node_modules/.pnpm/next@14.2.15_@babel+core@7.28.3_@opentelemetry+api@1.8.0_@playwright+test@1.55.0_babel-plugin_ekjgv7hsly3swe6l2podzgwqkm/node_modules/next/dist/client/link.js");
